module.exports = __webpack_public_path__ + "static/media/research-monitor-vs-measure.ef859853.png";